import { render, staticRenderFns } from "./TwoStageVerify.vue?vue&type=template&id=92b9f0aa&"
import script from "./TwoStageVerify.vue?vue&type=script&lang=js&"
export * from "./TwoStageVerify.vue?vue&type=script&lang=js&"
import style0 from "./TwoStageVerify.vue?vue&type=style&index=0&id=92b9f0aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports